import { useNavigate } from 'react-router-dom';

import {
  isErrorWithMessage,
  openErrorNotification,
  openSuccessNotification,
} from 'shared/lib';
import { GROUP_ROUTES } from 'shared/consts/routes/group';

import {
  useAddUsersGroupMutation,
  UsersGroupForm,
  UsersGroupFormData,
} from 'entities/users-group';

import { ADD_SUCCESS, ADD_ERROR } from '../consts';

type FormData = UsersGroupFormData;

const initialValues: FormData = {
  id: '',
  name: '',
};

export function AddUsersGroup() {
  const [trigger, { isLoading }] = useAddUsersGroupMutation();

  const navigate = useNavigate();

  const handleSubmit = async (values: FormData) => {
    const { name } = values;

    try {
      const res = await trigger({ name }).unwrap();

      // костыль
      if (res.statusCode !== 0) {
        openErrorNotification(res.statusDescription);

        return;
      }
      //

      openSuccessNotification(ADD_SUCCESS);

      navigate(GROUP_ROUTES.GROUPS);
    } catch (err) {
      const hasErrorMessage = isErrorWithMessage(err);

      const errorText = hasErrorMessage
        ? err.data.statusDescription
        : ADD_ERROR;

      openErrorNotification(errorText);
    }
  };

  return (
    <UsersGroupForm
      title="Добавление новой группы пользователей"
      handleSubmit={handleSubmit}
      initialValues={initialValues}
      loading={isLoading}
    />
  );
}
